export default "__VITE_ASSET__DXr0_HtA__"